<div class="charts">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
        <mat-icon>star_border</mat-icon>
        <div>
          <span>チャート動向</span>
          @if (!media.isActive('lt-md')) {
            <ng-container *ngTemplateOutlet="pageDateRenge"></ng-container>
          }
        </div>

        <mat-icon
          class="help"
          matTooltip="指定した期間のチャート（デイリーチャートの場合は指定した期間の最高値）情報です。ランクインしている時に表示されます。"
          >help_outline</mat-icon
          >
          <app-csv-download
            [id]="csvId"
            [fileName]="csvFileName"
            [csv]="csvData$ | async"
            [loading]="csvLoading$ | async"
            [artist]="selectedArtist$ | async"
          ></app-csv-download>
        </div>
        @if (media.isActive('lt-md')) {
          <ng-container *ngTemplateOutlet="spPageDateRenge"></ng-container>
        }
      </div>

    <div fxLayout="row wrap" fxLayoutGap="16px grid">
      @if (!(loading$ | async)) {
        @if (!(oriconAllEmpty$ | async)) {
          <div
            fxFlex.xl="1 1 25%"
            fxFlex.lg="1 1 33.3%"
            fxFlex.md="1 1 50%"
            fxFlex.sm="1 1 100%"
            fxFlex.xs="1 1 100%"
            >
            <app-chart-item-oricon></app-chart-item-oricon>
          </div>
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Oricon</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (iTunesInfo$ | async; as iTunes) {
          @if (iTunes.length > 0 && iTunes[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-itunes></app-chart-item-itunes>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>iTunes</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (amazonInfo$ | async; as amazon) {
          @if (amazon.length > 0 && amazon[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-amazon></app-chart-item-amazon>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Amazon</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (appleMusicInfo$ | async; as appleMusic) {
          @if (appleMusic.length > 0 && appleMusic[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-apple-music></app-chart-item-apple-music>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Apple Music</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (spotifyInfo$ | async; as spotifyInfo) {
          @if (spotifyInfo.length > 0 && spotifyInfo[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-spotify></app-chart-item-spotify>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Spotify</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (lineMusicInfo$ | async; as lineMusic) {
          @if (lineMusic.length > 0 && lineMusic[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-line></app-chart-item-line>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>LINE MUSIC</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (tiktokWeeklyInfo$ | async; as tiktokWeekly) {
          @if (tiktokWeekly.length > 0 && tiktokWeekly[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-tiktok></app-chart-item-tiktok>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Tiktok</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (shazamInfo$ | async; as shazam) {
          @if (shazam.length > 0 && shazam[0].chartItems.length > 0) {
            <div
              fxFlex.xl="1 1 25%"
              fxFlex.lg="1 1 33.3%"
              fxFlex.md="1 1 50%"
              fxFlex.sm="1 1 100%"
              fxFlex.xs="1 1 100%"
              >
              <app-chart-item-shazam></app-chart-item-shazam>
            </div>
          }
        }
      } @else {
        <div
          fxFlex.xl="1 1 25%"
          fxFlex.lg="1 1 33.3%"
          fxFlex.md="1 1 50%"
          fxFlex.sm="1 1 100%"
          fxFlex.xs="1 1 100%"
          >
          <mat-card>
            <mat-list>
              <h3>Shazam</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (allEmpty$ | async) {
          <div
            fxFlex.xl="1 1 25%"
            fxFlex.lg="1 1 33.3%"
            fxFlex.md="1 1 50%"
            fxFlex.sm="1 1 100%"
            fxFlex.xs="1 1 100%"
            >
            <mat-card>
              <mat-list>
                <span class="noranking">
                  該当なし
                </span>
              </mat-list>
            </mat-card>
          </div>
        }
      }
    </div>









    <ng-template #pageDateRenge>
      <span class="date-range">
        {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
        期間の集計データ
      </span>
    </ng-template>

    <ng-template #spPageDateRenge>
      <span class="sp-date-range">
        {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
        期間の集計データ
      </span>
    </ng-template>

